// extracted by mini-css-extract-plugin
export var addButton = "_60-d";
export var bullets = "_60-e";
export var compact = "_60-2";
export var container = "_60-j";
export var extendedWarrantyModal = "_60-f";
export var learn = "_60-l";
export var learnMore = "_60-g";
export var offeringOption = "_60-3";
export var offeringPrice = "_60-8";
export var offeringSubtitle = "_60-7";
export var offeringTitle = "_60-6";
export var offeringsContainer = "_60-0";
export var pdpTilesBackground = "_60-n";
export var plan = "_60-m";
export var regular = "_60-1";
export var remove = "_60-k";
export var seeDetailsIcon = "_60-i";
export var seeDetailsLink = "_60-h";
export var selectedOption = "_60-4";
export var shieldIcon = "_60-b";
export var shieldIconCompact = "_60-c";
export var subtitle = "_60-a";
export var title = "_60-9";
export var unselectedOption = "_60-5";